import { render } from "./PlacesAutocomplete.vue?vue&type=template&id=0bf364f8"
import script from "./PlacesAutocomplete?vue&type=script&lang=js&external"
export * from "./PlacesAutocomplete?vue&type=script&lang=js&external"

import "./PlacesAutocomplete.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__